// Getters
export const linksExternos = (state) => {
  return state.linksExternos.data || []
}
export const linksExternosLoading = (state) => {
  return state.linksExternos.loading
}
export const linksExternosLastUpdate = (state) => {
  return state.linksExternos.lastUpdate
}

